export default function ArticleListing({ products, onProductClick, itemsPerRow, itemSize = 1 }) {
  // Size config: [minHeight, fontSize, gap, padding]
  const sizeConfig = [
    { minHeight: '80px', fontSize: '14px', gap: '4px', padding: '8px' },   // Klein
    { minHeight: '110px', fontSize: '16px', gap: '6px', padding: '10px' }, // Mittel
    { minHeight: '140px', fontSize: '18px', gap: '8px', padding: '12px' }  // Groß
  ]
  const size = sizeConfig[itemSize] || sizeConfig[1]

  const styles = {
    container: {
      display: 'grid',
      gridTemplateColumns: itemsPerRow > 0 ? `repeat(${itemsPerRow}, 1fr)` : 'repeat(auto-fill, minmax(100px, 1fr))',
      gap: size.gap,
      padding: '10px',
      overflowY: 'auto',
    },
    button: {
      minHeight: size.minHeight,
      padding: size.padding,
      border: '2px solid #4ecdc4',
      borderRadius: '12px',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'all 0.2s',
      gap: size.gap,
    },
    name: {
      fontSize: size.fontSize,
      fontWeight: '600',
      textAlign: 'center',
      color: '#333',
      wordBreak: 'break-word',
    },
    price: {
      fontSize: size.fontSize,
      fontWeight: 'bold',
      color: '#333',
    },
  }

  return (
    <div style={styles.container}>
      {products.map((product) => (
        <button
          key={product.id}
          style={{ ...styles.button, background: product.color || '#fff' }}
          onClick={() => onProductClick(product)}
        >
          <span style={styles.name}>{product.name}</span>
          <span style={styles.price}>{(product.preis + (product.pfand || 0)).toFixed(2)}€</span>
        </button>
      ))}
    </div>
  )
}